import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {fanaticismConvertWinPoints, showToast, withToastIcon} from '../../../redux/actions';
import {selectCurrentPlayer, selectGameType, selectPlayers} from "../../../redux/reducers/sharedStateReducer/selectors";
import './PolicyFanaticismConversionButton.css'
import {REGISTRY_SINGLETON} from "../../../scenes/Registry";
import {useIsCurrentUserTurn} from "../../../utils/gameState/user/useIsCurrentUserCurrentPlayer";
import {selectUserId} from "../../../redux/reducers/privateStateReducer/selectors";
import {getActingPlayer} from "../../../utils/players/getActingPlayer";
import {isPlayerPolicy} from "../../../utils/factions/isPlayerPolicy";
import {POLICIES} from "../../../constants/policies";
import {
  POLICY_FANATICISM_COINS_CONVERSION,
  POLICY_FANATICISM_WIN_POINTS_CONVERSION
} from "../../../configs/policy/fanaticism";
import {WinPointsStat} from "../../PlayerStat/stats/WinPointsStat";
import {CoinsStat} from "../../PlayerStat/stats/CoinsStat";
import {selectIsParallelSupplyPhase} from "../../../utils/gameState/supply/parallelSupplySelectors";
import {GameButton} from "../../gameUi/GameButton";
import {joinClassNames} from "../../gameUi/joinClassNames";
import {TOAST_ICONS} from "../../../constants/toast";

const PolicyFanaticismConversionButton = () => {
  const dispatch = useDispatch();
  const gameType = useSelector(selectGameType);
  const userId = useSelector(selectUserId);
  const isCurrentUserTurn = useIsCurrentUserTurn();
  const currentPlayer = useSelector(selectCurrentPlayer);
  const players = useSelector(selectPlayers);
  const isParallelSupplyPhase = useSelector(selectIsParallelSupplyPhase);

  const actingPlayer = getActingPlayer(gameType, userId, players, currentPlayer);

  if (!isCurrentUserTurn || !isPlayerPolicy(actingPlayer, POLICIES.FANATICISM)) {
    return null;
  }

  const handleClick = () => {
    if (actingPlayer.isFanaticismConversionUsed) {
      dispatch(showToast(`Вы уже обменивали очки на монеты в этом раунде!`, 'warning', 5000));
      return;
    }

    if (actingPlayer.winPoints < POLICY_FANATICISM_WIN_POINTS_CONVERSION) {
      dispatch(showToast(`У Вас недостаточно очков для обмена!`, 'warning', 5000));
      return;
    }

    dispatch(withToastIcon(showToast(`Вы обменяли ${POLICY_FANATICISM_WIN_POINTS_CONVERSION} очка на ${POLICY_FANATICISM_COINS_CONVERSION} монет.`, 'success', 3000, true, true), TOAST_ICONS.COINS));
    // В одновременной фазе снабжения обмен идет за действующего игрока явно:
    // текущий игрок там — не тот, кто нажал
    dispatch(fanaticismConvertWinPoints(isParallelSupplyPhase ? actingPlayer.id : undefined));
    REGISTRY_SINGLETON.getSoundManager().playCoins(POLICY_FANATICISM_COINS_CONVERSION);
  };

  // Плита кнопки дизайн-системы матча. Обмен в этом раунде уже был —
  // «недоступный» вид, но нажатие остается: оно объясняет тостом, почему нельзя
  return (
    <GameButton
      onClick={(e) => {
        e.stopPropagation();
        handleClick();
      }}
      className={joinClassNames(
        'fanaticism-conversion-button',
        actingPlayer.isFanaticismConversionUsed && 'gui-disabled-look',
      )}
      title={'Обменять очки на монеты'}
    >
      <WinPointsStat
        text={POLICY_FANATICISM_WIN_POINTS_CONVERSION}
        noShrinkOnMobile={true}
        isLightColor={true}
      />
      <img
        className={'from-to-icon'}
        src={'/img/icons/up white.png'}
        alt={'Обменять'}
      />
      <CoinsStat
        text={POLICY_FANATICISM_COINS_CONVERSION}
        noShrinkOnMobile={true}
      />
    </GameButton>
  );
};

export default PolicyFanaticismConversionButton;